// extracted by mini-css-extract-plugin
export default {"container":"LerninhaltControls_container__VVVT3","button":"LerninhaltControls_button__ldiPH"};